import { render, staticRenderFns } from "./Recebimentos.vue?vue&type=template&id=117361b2"
import script from "./Recebimentos.vue?vue&type=script&lang=js"
export * from "./Recebimentos.vue?vue&type=script&lang=js"
import style0 from "./Recebimentos.vue?vue&type=style&index=0&id=117361b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports